import { BlockReasonDto as BlockReasonDtoMapper, BudgetDto as BudgetDtoMapper, BudgetCreateRequest as BudgetCreateRequestMapper, BudgetUpdateRequest as BudgetUpdateRequestMapper, CandidateMemberListCreateRequest as CandidateMemberListCreateRequestMapper, CandidateMemberCreateRequest as CandidateMemberCreateRequestMapper, CandidateMemberUpdateRequest as CandidateMemberUpdateRequestMapper, ClaimsReplacementPaymentRegistryByGroupRequest as ClaimsReplacementPaymentRegistryByGroupRequestMapper, ClaimsReplacementPaymentRegistryByItemIdsRequest as ClaimsReplacementPaymentRegistryByItemIdsRequestMapper, DashboardReplacementRegistryAnyClaimsRequest as DashboardReplacementRegistryAnyClaimsRequestMapper, DashboardRegistryAnyClaimsRequest as DashboardRegistryAnyClaimsRequestMapper, PaymentRegistryGenerateByGroupRequest as PaymentRegistryGenerateByGroupRequestMapper, PaymentRegistryGenerateByClaimsRequest as PaymentRegistryGenerateByClaimsRequestMapper, CorrectingPaymentRegistryGenerateRequest as CorrectingPaymentRegistryGenerateRequestMapper, CertificateCreateRequest as CertificateCreateRequestMapper, CertificateUpdateRequest as CertificateUpdateRequestMapper, CertificateAttachRequest as CertificateAttachRequestMapper, CertificateRequest as CertificateRequestMapper, CertificateTransferRequest as CertificateTransferRequestMapper, ClaimsDocumentsArchiveRequest as ClaimsDocumentsArchiveRequestMapper, ClaimAmountsDto as ClaimAmountsDtoMapper, DataFilter as DataFilterMapper, ClientAppCreateRequest as ClientAppCreateRequestMapper, CreateCompetitionRequest as CreateCompetitionRequestMapper, UpdateCompetitionRequest as UpdateCompetitionRequestMapper, ClaimMessageCreateRequest as ClaimMessageCreateRequestMapper, InfoMessageContract as InfoMessageContractMapper, InfoMessageRejectDto as InfoMessageRejectDtoMapper, SetInfoMessageRequestStatusApiModel as SetInfoMessageRequestStatusApiModelMapper, ParticipationCertificateCreationDto as ParticipationCertificateCreationDtoMapper, MemberAccessExtendRequest as MemberAccessExtendRequestMapper, MemberAccessBlockRequest as MemberAccessBlockRequestMapper, MemberAccessCreateRequest as MemberAccessCreateRequestMapper, ChangeMemberDataRequestDto as ChangeMemberDataRequestDtoMapper, ChangeMemberEmailRequestDto as ChangeMemberEmailRequestDtoMapper, ParameterizedQuery as ParameterizedQueryMapper, ExportOptions as ExportOptionsMapper, UpdateTestimonialDto as UpdateTestimonialDtoMapper, AgentReportCreateDto as AgentReportCreateDtoMapper, AgentReportUpdateDto as AgentReportUpdateDtoMapper, InformationMessageInput as InformationMessageInputMapper, ProgramDto as ProgramDtoMapper, ProjectCreateRequest as ProjectCreateRequestMapper, ProjectUpdateRequest as ProjectUpdateRequestMapper, ProviderDto as ProviderDtoMapper, ResultClaimFileToConvertDto as ResultClaimFileToConvertDtoMapper, ResultClaimSetResponsibleUser as ResultClaimSetResponsibleUserMapper, ResultClaimSetComment as ResultClaimSetCommentMapper, ResultGroupUpdateRequest as ResultGroupUpdateRequestMapper, AcceptHashRecordsRsvApiDto as AcceptHashRecordsRsvApiDtoMapper, SuccessHistoryCreateDto as SuccessHistoryCreateDtoMapper, TelegramLinkUpdateDto as TelegramLinkUpdateDtoMapper, UserCreateRequest as UserCreateRequestMapper, UserPasswordResetRequest as UserPasswordResetRequestMapper, UserConfirmRequest as UserConfirmRequestMapper, UserUpdateRequest as UserUpdateRequestMapper, UserToBudgetAccessDto as UserToBudgetAccessDtoMapper } from "../models/mappers";
export const $host = {
    parameterPath: "$host",
    mapper: {
        serializedName: "$host",
        required: true,
        type: {
            name: "String"
        }
    },
    skipEncoding: true
};
export const accept = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/json, text/json",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const contentType = {
    parameterPath: ["options", "contentType"],
    mapper: {
        defaultValue: "application/json-patch+json",
        isConstant: true,
        serializedName: "Content-Type",
        type: {
            name: "String"
        }
    }
};
export const body = {
    parameterPath: ["options", "body"],
    mapper: BlockReasonDtoMapper
};
export const id = {
    parameterPath: "id",
    mapper: {
        serializedName: "id",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body1 = {
    parameterPath: ["options", "body"],
    mapper: BudgetDtoMapper
};
export const body2 = {
    parameterPath: ["options", "body"],
    mapper: BudgetCreateRequestMapper
};
export const body3 = {
    parameterPath: ["options", "body"],
    mapper: BudgetUpdateRequestMapper
};
export const budgetId = {
    parameterPath: "budgetId",
    mapper: {
        serializedName: "budgetId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const claimNumber = {
    parameterPath: "claimNumber",
    mapper: {
        serializedName: "claimNumber",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const listId = {
    parameterPath: "listId",
    mapper: {
        serializedName: "listId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const contentType1 = {
    parameterPath: ["options", "contentType"],
    mapper: {
        defaultValue: "multipart/form-data",
        isConstant: true,
        serializedName: "Content-Type",
        type: {
            name: "String"
        }
    }
};
export const files = {
    parameterPath: ["options", "files"],
    mapper: {
        serializedName: "files",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const accept1 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/json, text/json",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const includeCandidateMembers = {
    parameterPath: ["options", "includeCandidateMembers"],
    mapper: {
        defaultValue: false,
        serializedName: "includeCandidateMembers",
        type: {
            name: "Boolean"
        }
    }
};
export const candidateId = {
    parameterPath: "candidateId",
    mapper: {
        serializedName: "candidateId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const memberId = {
    parameterPath: "memberId",
    mapper: {
        serializedName: "memberId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const includeDuplicates = {
    parameterPath: ["options", "includeDuplicates"],
    mapper: {
        defaultValue: false,
        serializedName: "includeDuplicates",
        type: {
            name: "Boolean"
        }
    }
};
export const candidateMemberId = {
    parameterPath: ["options", "candidateMemberId"],
    mapper: {
        serializedName: "candidateMemberId",
        type: {
            name: "Number"
        }
    }
};
export const body4 = {
    parameterPath: ["options", "body"],
    mapper: {
        serializedName: "body",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export const withoutAccess = {
    parameterPath: ["options", "withoutAccess"],
    mapper: {
        defaultValue: false,
        serializedName: "withoutAccess",
        type: {
            name: "Boolean"
        }
    }
};
export const file = {
    parameterPath: ["options", "file"],
    mapper: {
        serializedName: "file",
        type: {
            name: "Stream"
        }
    }
};
export const isSpecialProject = {
    parameterPath: ["options", "isSpecialProject"],
    mapper: {
        defaultValue: false,
        serializedName: "isSpecialProject",
        type: {
            name: "Boolean"
        }
    }
};
export const autoLoad = {
    parameterPath: ["options", "autoLoad"],
    mapper: {
        defaultValue: false,
        serializedName: "autoLoad",
        type: {
            name: "Boolean"
        }
    }
};
export const body5 = {
    parameterPath: ["options", "body"],
    mapper: CandidateMemberListCreateRequestMapper
};
export const body6 = {
    parameterPath: ["options", "body"],
    mapper: CandidateMemberCreateRequestMapper
};
export const body7 = {
    parameterPath: ["options", "body"],
    mapper: CandidateMemberUpdateRequestMapper
};
export const candidateMemberListId = {
    parameterPath: ["options", "candidateMemberListId"],
    mapper: {
        serializedName: "CandidateMemberListId",
        type: {
            name: "Number"
        }
    }
};
export const budgetId1 = {
    parameterPath: ["options", "budgetId"],
    mapper: {
        serializedName: "BudgetId",
        type: {
            name: "Number"
        }
    }
};
export const candidateId1 = {
    parameterPath: ["options", "candidateId"],
    mapper: {
        serializedName: "candidateId",
        type: {
            name: "Number"
        }
    }
};
export const email = {
    parameterPath: ["options", "email"],
    mapper: {
        serializedName: "email",
        type: {
            name: "String"
        }
    }
};
export const memberId1 = {
    parameterPath: ["options", "memberId"],
    mapper: {
        serializedName: "memberId",
        type: {
            name: "Number"
        }
    }
};
export const certificatePaymentRegistryId = {
    parameterPath: ["options", "certificatePaymentRegistryId"],
    mapper: {
        serializedName: "certificatePaymentRegistryId",
        type: {
            name: "Uuid"
        }
    }
};
export const certificatePaymentRegistryStatusId = {
    parameterPath: ["options", "certificatePaymentRegistryStatusId"],
    mapper: {
        serializedName: "certificatePaymentRegistryStatusId",
        type: {
            name: "Number"
        }
    }
};
export const body8 = {
    parameterPath: ["options", "body"],
    mapper: ClaimsReplacementPaymentRegistryByGroupRequestMapper
};
export const body9 = {
    parameterPath: ["options", "body"],
    mapper: ClaimsReplacementPaymentRegistryByItemIdsRequestMapper
};
export const body10 = {
    parameterPath: ["options", "body"],
    mapper: DashboardReplacementRegistryAnyClaimsRequestMapper
};
export const body11 = {
    parameterPath: ["options", "body"],
    mapper: DashboardRegistryAnyClaimsRequestMapper
};
export const certificatePaymentRegistryId1 = {
    parameterPath: "certificatePaymentRegistryId",
    mapper: {
        serializedName: "certificatePaymentRegistryId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const groupId = {
    parameterPath: ["options", "groupId"],
    mapper: {
        serializedName: "groupId",
        type: {
            name: "Uuid"
        }
    }
};
export const body12 = {
    parameterPath: ["options", "body"],
    mapper: PaymentRegistryGenerateByGroupRequestMapper
};
export const accept2 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/octet-stream",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const body13 = {
    parameterPath: ["options", "body"],
    mapper: PaymentRegistryGenerateByClaimsRequestMapper
};
export const body14 = {
    parameterPath: ["options", "body"],
    mapper: CorrectingPaymentRegistryGenerateRequestMapper
};
export const accept3 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const file1 = {
    parameterPath: ["options", "file"],
    mapper: {
        serializedName: "File",
        type: {
            name: "Stream"
        }
    }
};
export const budgetId2 = {
    parameterPath: ["options", "budgetId"],
    mapper: {
        serializedName: "BudgetId",
        type: {
            name: "Number"
        }
    }
};
export const registryType = {
    parameterPath: ["options", "registryType"],
    mapper: {
        serializedName: "RegistryType",
        type: {
            name: "String"
        }
    }
};
export const body15 = {
    parameterPath: ["options", "body"],
    mapper: CertificateCreateRequestMapper
};
export const body16 = {
    parameterPath: ["options", "body"],
    mapper: CertificateUpdateRequestMapper
};
export const certificateId = {
    parameterPath: "certificateId",
    mapper: {
        serializedName: "certificateId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body17 = {
    parameterPath: ["options", "body"],
    mapper: CertificateAttachRequestMapper
};
export const body18 = {
    parameterPath: ["options", "body"],
    mapper: CertificateRequestMapper
};
export const body19 = {
    parameterPath: ["options", "body"],
    mapper: CertificateTransferRequestMapper
};
export const formFiles = {
    parameterPath: ["options", "formFiles"],
    mapper: {
        serializedName: "formFiles",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const changeStatus = {
    parameterPath: ["options", "changeStatus"],
    mapper: {
        serializedName: "changeStatus",
        type: {
            name: "Boolean"
        }
    }
};
export const newStatus = {
    parameterPath: ["options", "newStatus"],
    mapper: {
        serializedName: "newStatus",
        type: {
            name: "Number"
        }
    }
};
export const fileType = {
    parameterPath: ["options", "fileType"],
    mapper: {
        serializedName: "fileType",
        type: {
            name: "Number"
        }
    }
};
export const claimId = {
    parameterPath: "claimId",
    mapper: {
        serializedName: "claimId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const fileId = {
    parameterPath: "fileId",
    mapper: {
        serializedName: "fileId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const tickets = {
    parameterPath: ["options", "tickets"],
    mapper: {
        serializedName: "tickets",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const vouchers = {
    parameterPath: ["options", "vouchers"],
    mapper: {
        serializedName: "vouchers",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const insurance = {
    parameterPath: ["options", "insurance"],
    mapper: {
        serializedName: "insurance",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const accomodation = {
    parameterPath: ["options", "accomodation"],
    mapper: {
        serializedName: "accomodation",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const absent = {
    parameterPath: ["options", "absent"],
    mapper: {
        serializedName: "absent",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const explanatory = {
    parameterPath: ["options", "explanatory"],
    mapper: {
        serializedName: "explanatory",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const compress = {
    parameterPath: ["options", "compress"],
    mapper: {
        serializedName: "compress",
        type: {
            name: "Boolean"
        }
    }
};
export const agencyReports = {
    parameterPath: ["options", "agencyReports"],
    mapper: {
        serializedName: "agencyReports",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const claims = {
    parameterPath: ["options", "claims"],
    mapper: {
        serializedName: "claims",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const acts = {
    parameterPath: ["options", "acts"],
    mapper: {
        serializedName: "acts",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const registries = {
    parameterPath: ["options", "registries"],
    mapper: {
        serializedName: "registries",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const bookingLists = {
    parameterPath: ["options", "bookingLists"],
    mapper: {
        serializedName: "bookingLists",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const paymentOrders = {
    parameterPath: ["options", "paymentOrders"],
    mapper: {
        serializedName: "paymentOrders",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Stream"
                }
            }
        }
    }
};
export const contentType2 = {
    parameterPath: ["options", "contentType"],
    mapper: {
        serializedName: "ContentType",
        type: {
            name: "String"
        }
    }
};
export const contentDisposition = {
    parameterPath: ["options", "contentDisposition"],
    mapper: {
        serializedName: "ContentDisposition",
        type: {
            name: "String"
        }
    }
};
export const headers = {
    parameterPath: ["options", "headers"],
    mapper: {
        serializedName: "Headers",
        type: {
            name: "Dictionary",
            value: {
                type: { name: "Sequence", element: { type: { name: "String" } } }
            }
        }
    }
};
export const length = {
    parameterPath: ["options", "length"],
    mapper: {
        serializedName: "Length",
        type: {
            name: "Number"
        }
    }
};
export const name = {
    parameterPath: ["options", "name"],
    mapper: {
        serializedName: "Name",
        type: {
            name: "String"
        }
    }
};
export const fileName = {
    parameterPath: ["options", "fileName"],
    mapper: {
        serializedName: "FileName",
        type: {
            name: "String"
        }
    }
};
export const groupNumber = {
    parameterPath: "groupNumber",
    mapper: {
        serializedName: "groupNumber",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const groupId1 = {
    parameterPath: "groupId",
    mapper: {
        serializedName: "groupId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const statusId = {
    parameterPath: "statusId",
    mapper: {
        serializedName: "statusId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body20 = {
    parameterPath: ["options", "body"],
    mapper: ClaimsDocumentsArchiveRequestMapper
};
export const claimId1 = {
    parameterPath: ["options", "claimId"],
    mapper: {
        serializedName: "claimId",
        type: {
            name: "Uuid"
        }
    }
};
export const fileName1 = {
    parameterPath: ["options", "fileName"],
    mapper: {
        serializedName: "fileName",
        type: {
            name: "String"
        }
    }
};
export const tourGroupId = {
    parameterPath: "tourGroupId",
    mapper: {
        serializedName: "tourGroupId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const claimState = {
    parameterPath: ["options", "claimState"],
    mapper: {
        serializedName: "claimState",
        type: {
            name: "String"
        }
    }
};
export const externalTourGroupId = {
    parameterPath: "externalTourGroupId",
    mapper: {
        serializedName: "externalTourGroupId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body21 = {
    parameterPath: ["options", "body"],
    mapper: {
        serializedName: "body",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Uuid"
                }
            }
        }
    }
};
export const body22 = {
    parameterPath: ["options", "body"],
    mapper: ClaimAmountsDtoMapper
};
export const body23 = {
    parameterPath: ["options", "body"],
    mapper: DataFilterMapper
};
export const body24 = {
    parameterPath: ["options", "body"],
    mapper: ClientAppCreateRequestMapper
};
export const clientId = {
    parameterPath: "clientId",
    mapper: {
        serializedName: "clientId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body25 = {
    parameterPath: ["options", "body"],
    mapper: CreateCompetitionRequestMapper
};
export const body26 = {
    parameterPath: ["options", "body"],
    mapper: UpdateCompetitionRequestMapper
};
export const claimId2 = {
    parameterPath: "claimId",
    mapper: {
        serializedName: "claimId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const messageId = {
    parameterPath: "messageId",
    mapper: {
        serializedName: "messageId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body27 = {
    parameterPath: ["options", "body"],
    mapper: ClaimMessageCreateRequestMapper
};
export const messageId1 = {
    parameterPath: ["options", "messageId"],
    mapper: {
        serializedName: "messageId",
        type: {
            name: "Uuid"
        }
    }
};
export const statusId1 = {
    parameterPath: ["options", "statusId"],
    mapper: {
        serializedName: "statusId",
        type: {
            name: "Number"
        }
    }
};
export const accept4 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/pdf",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const externalTourId = {
    parameterPath: "externalTourId",
    mapper: {
        serializedName: "externalTourId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body28 = {
    parameterPath: ["options", "body"],
    mapper: InfoMessageContractMapper
};
export const body29 = {
    parameterPath: ["options", "body"],
    mapper: InfoMessageRejectDtoMapper
};
export const accIntegration = {
    parameterPath: "accIntegration",
    mapper: {
        serializedName: "accIntegration",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const status = {
    parameterPath: ["options", "status"],
    mapper: {
        serializedName: "status",
        type: {
            name: "Number"
        }
    }
};
export const body30 = {
    parameterPath: ["options", "body"],
    mapper: SetInfoMessageRequestStatusApiModelMapper
};
export const traceId = {
    parameterPath: ["options", "traceId"],
    mapper: {
        serializedName: "TraceId",
        type: {
            name: "Uuid"
        }
    }
};
export const fileId1 = {
    parameterPath: "fileId",
    mapper: {
        serializedName: "FileId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const traceId1 = {
    parameterPath: ["options", "traceId"],
    mapper: {
        serializedName: "TraceId",
        type: {
            name: "Uuid"
        }
    }
};
export const file2 = {
    parameterPath: "file",
    mapper: {
        serializedName: "File",
        required: true,
        type: {
            name: "Stream"
        }
    }
};
export const body31 = {
    parameterPath: ["options", "body"],
    mapper: ParticipationCertificateCreationDtoMapper
};
export const accessId = {
    parameterPath: "accessId",
    mapper: {
        serializedName: "accessId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body32 = {
    parameterPath: ["options", "body"],
    mapper: MemberAccessExtendRequestMapper
};
export const accessId1 = {
    parameterPath: "accessId",
    mapper: {
        serializedName: "accessId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body33 = {
    parameterPath: ["options", "body"],
    mapper: MemberAccessBlockRequestMapper
};
export const body34 = {
    parameterPath: ["options", "body"],
    mapper: MemberAccessCreateRequestMapper
};
export const body35 = {
    parameterPath: ["options", "body"],
    mapper: ChangeMemberDataRequestDtoMapper
};
export const requestId = {
    parameterPath: "requestId",
    mapper: {
        serializedName: "requestId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body36 = {
    parameterPath: ["options", "body"],
    mapper: ChangeMemberEmailRequestDtoMapper
};
export const body37 = {
    parameterPath: ["options", "body"],
    mapper: ParameterizedQueryMapper
};
export const body38 = {
    parameterPath: ["options", "body"],
    mapper: ExportOptionsMapper
};
export const body39 = {
    parameterPath: ["options", "body"],
    mapper: UpdateTestimonialDtoMapper
};
export const withStamp = {
    parameterPath: ["options", "withStamp"],
    mapper: {
        defaultValue: false,
        serializedName: "withStamp",
        type: {
            name: "Boolean"
        }
    }
};
export const isPdf = {
    parameterPath: ["options", "isPdf"],
    mapper: {
        defaultValue: false,
        serializedName: "isPdf",
        type: {
            name: "Boolean"
        }
    }
};
export const dayIncludePeriod = {
    parameterPath: ["options", "dayIncludePeriod"],
    mapper: {
        serializedName: "dayIncludePeriod",
        type: {
            name: "Number"
        }
    }
};
export const periodDate = {
    parameterPath: "periodDate",
    mapper: {
        serializedName: "periodDate",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const providerId = {
    parameterPath: "providerId",
    mapper: {
        serializedName: "providerId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body40 = {
    parameterPath: ["options", "body"],
    mapper: AgentReportCreateDtoMapper
};
export const agentReportId = {
    parameterPath: "agentReportId",
    mapper: {
        serializedName: "agentReportId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body41 = {
    parameterPath: ["options", "body"],
    mapper: AgentReportUpdateDtoMapper
};
export const requestId1 = {
    parameterPath: "requestId",
    mapper: {
        serializedName: "requestId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const body42 = {
    parameterPath: ["options", "body"],
    mapper: InformationMessageInputMapper
};
export const accept5 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const accept6 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "image/jpeg",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const width = {
    parameterPath: "width",
    mapper: {
        defaultValue: 1024,
        serializedName: "width",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const height = {
    parameterPath: "height",
    mapper: {
        defaultValue: 1024,
        serializedName: "height",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const accept7 = {
    parameterPath: "accept",
    mapper: {
        defaultValue: "image/jpeg",
        isConstant: true,
        serializedName: "Accept",
        type: {
            name: "String"
        }
    }
};
export const body43 = {
    parameterPath: ["options", "body"],
    mapper: ProgramDtoMapper
};
export const providerId1 = {
    parameterPath: ["options", "providerId"],
    mapper: {
        serializedName: "providerId",
        type: {
            name: "Number"
        }
    }
};
export const body44 = {
    parameterPath: ["options", "body"],
    mapper: ProjectCreateRequestMapper
};
export const body45 = {
    parameterPath: ["options", "body"],
    mapper: ProjectUpdateRequestMapper
};
export const projectId = {
    parameterPath: "projectId",
    mapper: {
        serializedName: "ProjectId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const projectId1 = {
    parameterPath: "projectId",
    mapper: {
        serializedName: "projectId",
        required: true,
        type: {
            name: "Number"
        }
    }
};
export const userId = {
    parameterPath: "userId",
    mapper: {
        serializedName: "userId",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const userId1 = {
    parameterPath: ["options", "userId"],
    mapper: {
        serializedName: "userId",
        type: {
            name: "String"
        }
    }
};
export const providerIds = {
    parameterPath: ["options", "providerIds"],
    mapper: {
        serializedName: "providerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export const userId2 = {
    parameterPath: "userId",
    mapper: {
        serializedName: "userId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body46 = {
    parameterPath: ["options", "body"],
    mapper: ProviderDtoMapper
};
export const claimId3 = {
    parameterPath: ["options", "claimId"],
    mapper: {
        serializedName: "claimId",
        type: {
            name: "Uuid"
        }
    }
};
export const resultClaimTourOperatorStatusId = {
    parameterPath: ["options", "resultClaimTourOperatorStatusId"],
    mapper: {
        serializedName: "resultClaimTourOperatorStatusId",
        type: {
            name: "Number"
        }
    }
};
export const resultClaimAdministratorStatusId = {
    parameterPath: ["options", "resultClaimAdministratorStatusId"],
    mapper: {
        serializedName: "resultClaimAdministratorStatusId",
        type: {
            name: "Number"
        }
    }
};
export const group = {
    parameterPath: ["options", "group"],
    mapper: {
        serializedName: "group",
        type: {
            name: "String"
        }
    }
};
export const checkStatusId = {
    parameterPath: ["options", "checkStatusId"],
    mapper: {
        serializedName: "checkStatusId",
        type: {
            name: "Number"
        }
    }
};
export const body47 = {
    parameterPath: ["options", "body"],
    mapper: {
        serializedName: "body",
        type: {
            name: "String"
        }
    }
};
export const body48 = {
    parameterPath: ["options", "body"],
    mapper: ResultClaimFileToConvertDtoMapper
};
export const body49 = {
    parameterPath: ["options", "body"],
    mapper: ResultClaimSetResponsibleUserMapper
};
export const body50 = {
    parameterPath: ["options", "body"],
    mapper: ResultClaimSetCommentMapper
};
export const resultGroupId = {
    parameterPath: "resultGroupId",
    mapper: {
        serializedName: "resultGroupId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body51 = {
    parameterPath: ["options", "body"],
    mapper: ResultGroupUpdateRequestMapper
};
export const roleName = {
    parameterPath: ["options", "roleName"],
    mapper: {
        serializedName: "roleName",
        type: {
            name: "String"
        }
    }
};
export const fromLastTransferDate = {
    parameterPath: ["options", "fromLastTransferDate"],
    mapper: {
        serializedName: "fromLastTransferDate",
        type: {
            name: "DateTime"
        }
    }
};
export const limit = {
    parameterPath: ["options", "limit"],
    mapper: {
        serializedName: "limit",
        type: {
            name: "Number"
        }
    }
};
export const autoConfirmTransfer = {
    parameterPath: ["options", "autoConfirmTransfer"],
    mapper: {
        serializedName: "autoConfirmTransfer",
        type: {
            name: "Boolean"
        }
    }
};
export const accIntegration1 = {
    parameterPath: ["options", "accIntegration"],
    mapper: {
        serializedName: "accIntegration",
        type: {
            name: "String"
        }
    }
};
export const projectId2 = {
    parameterPath: ["options", "projectId"],
    mapper: {
        serializedName: "projectId",
        type: {
            name: "Number"
        }
    }
};
export const candidateMemberListId1 = {
    parameterPath: ["options", "candidateMemberListId"],
    mapper: {
        serializedName: "candidateMemberListId",
        type: {
            name: "Number"
        }
    }
};
export const body52 = {
    parameterPath: ["options", "body"],
    mapper: AcceptHashRecordsRsvApiDtoMapper
};
export const paymentRegistryId = {
    parameterPath: ["options", "paymentRegistryId"],
    mapper: {
        serializedName: "paymentRegistryId",
        type: {
            name: "Uuid"
        }
    }
};
export const body53 = {
    parameterPath: ["options", "body"],
    mapper: {
        serializedName: "body",
        type: {
            name: "Uuid"
        }
    }
};
export const statusPaymentRegistry = {
    parameterPath: ["options", "statusPaymentRegistry"],
    mapper: {
        serializedName: "statusPaymentRegistry",
        type: {
            name: "Number"
        }
    }
};
export const query = {
    parameterPath: ["options", "query"],
    mapper: {
        serializedName: "query",
        type: {
            name: "String"
        }
    }
};
export const mode = {
    parameterPath: ["options", "mode"],
    mapper: {
        serializedName: "mode",
        type: {
            name: "String"
        }
    }
};
export const userId3 = {
    parameterPath: ["options", "userId"],
    mapper: {
        serializedName: "userId",
        type: {
            name: "Uuid"
        }
    }
};
export const accessTokenId = {
    parameterPath: ["options", "accessTokenId"],
    mapper: {
        serializedName: "accessTokenId",
        type: {
            name: "Uuid"
        }
    }
};
export const accessTokenId1 = {
    parameterPath: "accessTokenId",
    mapper: {
        serializedName: "accessTokenId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body54 = {
    parameterPath: ["options", "body"],
    mapper: SuccessHistoryCreateDtoMapper
};
export const body55 = {
    parameterPath: ["options", "body"],
    mapper: {
        serializedName: "body",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const authorization = {
    parameterPath: ["options", "authorization"],
    mapper: {
        serializedName: "Authorization",
        type: {
            name: "String"
        }
    }
};
export const phone = {
    parameterPath: ["options", "phone"],
    mapper: {
        serializedName: "phone",
        type: {
            name: "String"
        }
    }
};
export const body56 = {
    parameterPath: ["options", "body"],
    mapper: TelegramLinkUpdateDtoMapper
};
export const groupId2 = {
    parameterPath: "groupId",
    mapper: {
        serializedName: "groupId",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
export const body57 = {
    parameterPath: ["options", "body"],
    mapper: UserCreateRequestMapper
};
export const login = {
    parameterPath: ["options", "login"],
    mapper: {
        serializedName: "login",
        type: {
            name: "String"
        }
    }
};
export const newPassword = {
    parameterPath: ["options", "newPassword"],
    mapper: {
        serializedName: "newPassword",
        type: {
            name: "String"
        }
    }
};
export const email1 = {
    parameterPath: "email",
    mapper: {
        serializedName: "email",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const token = {
    parameterPath: "token",
    mapper: {
        serializedName: "token",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const body58 = {
    parameterPath: ["options", "body"],
    mapper: UserPasswordResetRequestMapper
};
export const login1 = {
    parameterPath: "login",
    mapper: {
        serializedName: "login",
        required: true,
        type: {
            name: "String"
        }
    }
};
export const block = {
    parameterPath: "block",
    mapper: {
        serializedName: "block",
        required: true,
        type: {
            name: "Boolean"
        }
    }
};
export const body59 = {
    parameterPath: ["options", "body"],
    mapper: UserConfirmRequestMapper
};
export const take = {
    parameterPath: ["options", "take"],
    mapper: {
        serializedName: "Take",
        type: {
            name: "Number"
        }
    }
};
export const skip = {
    parameterPath: ["options", "skip"],
    mapper: {
        serializedName: "Skip",
        type: {
            name: "Number"
        }
    }
};
export const searchString = {
    parameterPath: ["options", "searchString"],
    mapper: {
        serializedName: "SearchString",
        type: {
            name: "String"
        }
    }
};
export const sortOrder = {
    parameterPath: ["options", "sortOrder"],
    mapper: {
        serializedName: "SortOrder",
        type: {
            name: "String"
        }
    }
};
export const body60 = {
    parameterPath: ["options", "body"],
    mapper: UserUpdateRequestMapper
};
export const body61 = {
    parameterPath: ["options", "body"],
    mapper: UserToBudgetAccessDtoMapper
};
export const id1 = {
    parameterPath: "id",
    mapper: {
        serializedName: "id",
        required: true,
        type: {
            name: "Uuid"
        }
    }
};
